export default function block_button() {
	$('.felds-button-anchor a').click(function(e){
		e.preventDefault();

		$('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top - 35
    }, 800);
	});
	
	if( window.acf ) {
		$(document).on('click', '.felds-button-block a', function(e){
			e.preventDefault();
		});
	}
}
